import type { ConnectProto } from "@racoon/api";

export type OrderPicks = {
  location?: ConnectProto.PickupLocation;
  customer?: ConnectProto.Organization;
};

/**
 * The create dialog's picks, handed from its body to its header: the modal renders the two
 * apart, and has no way to update a title once open.
 */
export const createOrderPicks = () => {
  let picks: OrderPicks = {};
  const listeners = new Set<() => void>();
  return {
    get: () => picks,
    set: (next: OrderPicks) => {
      picks = next;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
};
export type OrderPicksStore = ReturnType<typeof createOrderPicks>;
